import { render, staticRenderFns } from "./MatchedPatients.vue?vue&type=template&id=38ce7904&scoped=true&"
import script from "./MatchedPatients.vue?vue&type=script&lang=js&"
export * from "./MatchedPatients.vue?vue&type=script&lang=js&"
import style0 from "./MatchedPatients.vue?vue&type=style&index=0&id=38ce7904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ce7904",
  null
  
)

export default component.exports